{
  "es": {
    "filteredList": {
      "actions": {
        "showFilter": "Show Filters",
        "hideFilter": "Hide Filters"
      }
    }
  },
  "en": {
    "filteredList": {
      "actions": {
        "showFilter": "Show Filters",
        "hideFilter": "Hide Filters"
      }
    }
  }
}
